(ns ui.view.nev.event
  (:require
   [common.schema.view.single-entity :as sevs]
   [frontend.controller.websocket.event :as ws]
   [frontend.local-storage :as ls]
   [frontend.routing :as routing]
   [frontend.test-nev-v3.event :as test-nev-v3-event]
   [oops.core :as oops]
   [potpuri.core :as p]
   [re-frame.core :as rf]

   ;; TODO fix this somehow
   [ui.cofx.account :as account-cofx]
   [ui.cofx.response :as response-cofx]
   [ui.editors.nev-view-editor.event :as nev-view-editor-event]
   [ui.state.session.cofx :as session-cofx]
   [ui.state.session.model :as session-model]
   [ui.view.nev.model :as model]))

(def sidebar-mode-ls-key :nev-2024-sidebar-mode)

(def save-sidebar-mode-to-local-storage
  (rf/->interceptor
   {:id    ::save-sidebar-mode-to-local-storage
    :after (fn [args]
             (let [ctx (-> args
                           (get-in [:coeffects :original-event])
                           second)
                   db (get-in args [:effects :db])
                   state-path (:state-path ctx)
                   sidebar-mode (get-in db (model/sidebar-mode-full-path state-path))]
               (when (#{:collapsed :expanded} sidebar-mode)
                 (ls/set sidebar-mode-ls-key sidebar-mode))
               args))}))

(def get-sidebar-mode-from-local-storage
  (rf/->interceptor
   {:id     ::get-sidebar-mode-from-local-storage
    :before (fn [args]
              (let [sidebar-mode (ls/get sidebar-mode-ls-key)]
                (if (#{:collapsed :expanded} sidebar-mode)
                  (assoc-in args [:coeffects :sidebar-mode] sidebar-mode)
                  args)))}))

(defn fetch-sidebar-data-request
  [{:keys [view-entity viewed-entity-id ctx]}]
  {:uri        "/nev/query"
   :method     :post
   :body       {:id     :get-sidebar-entities
                :params {:view-entity      view-entity
                         :viewed-entity-id viewed-entity-id}}
   :signal     (:signal ctx)
   :on-success [::fetch-sidebar-data-success ctx]
   :on-failure [::fetch-sidebar-data-failure ctx]})

(defn open-view-event-fx-handler
  [{:keys [db sidebar-mode]}
   [{:keys [view-id view-entity cards entity-id state-path] :as ctx}]]
  (let [view-entity (or view-entity
                        (session-model/get-entity db view-id))
        view-id (:db/id view-entity)
        viewed-entity-type (:view/entity-type view-entity)
        cards (or cards
                  (->> view-entity
                       :view/cards
                       (mapv #(session-model/get-entity db %))))
        entities-by-id (merge
                        {view-id view-entity}
                        (p/index-by :db/id cards))

        new-db (-> db
                   (p/dissoc-in state-path)                                                         ;; Clear prev state if exists
                   (assoc-in (model/initialized-full-path state-path) true)
                   (assoc-in (model/view-id-full-path state-path) view-id)
                   (assoc-in (model/primary-entity-id-full-path state-path) entity-id)
                   (assoc-in (model/primary-entity-type-full-path state-path) viewed-entity-type)
                   (assoc-in (model/entities-full-path state-path) entities-by-id)
                   (assoc-in (model/sidebar-mode-full-path state-path) (or sidebar-mode :pinned))
                   (assoc-in (model/selected-entity-id-full-path state-path) entity-id)
                   (assoc-in (model/selected-entity-type-full-path state-path) viewed-entity-type)
                   (assoc-in (model/selected-top-level-section-full-path state-path) :primary-entity)
                   (assoc-in (model/selected-section-full-path state-path) (sevs/summary-section-id viewed-entity-type)))]
    {:db new-db
     :fx [[:fetch (fetch-sidebar-data-request
                   {:view-entity      view-entity
                    :viewed-entity-id entity-id
                    :ctx              ctx})]]}))

(rf/reg-event-fx
 ::open-view
 [rf/trim-v
  get-sidebar-mode-from-local-storage]
 open-view-event-fx-handler)

(rf/reg-event-fx
 ::open-default-view
 [rf/trim-v
  (rf/inject-cofx ::account-cofx/favorite-single-entity-views)]
 (fn [{:keys [db favorite-single-entity-views]}
      [{:keys [entity-id entity-type state-path subscribe-to-realtime-changes? signal] :as _ctx}]]
   (let [favorite-view-id (get favorite-single-entity-views entity-type)
         ;; TODO: remove once real default views and cards are implemented better way
         new-db (session-model/merge-entities db test-nev-v3-event/entities-by-id)

         favorite-view-exists? (and favorite-view-id
                                    (session-model/get-entity new-db favorite-view-id))
         view-id (or (when favorite-view-exists?
                       favorite-view-id)
                     (case entity-type
                       :entity.type/company "default-company-view"
                       :entity.type/person "default-person-view"
                       :entity.type/oppo "deal-attachments-test-view"
                       :entity.type/survey-profile "default-survey-profile-view"
                       :entity.type/project-counterparty-diligence "project-counterparty-diligence-view-1"
                       :entity.type/company-counterparty-diligence "company-counterparty-diligence-view-1"
                       :entity.type/person-counterparty-diligence "person-counterparty-diligence-view-1"))]
     {:db new-db
      :fx [[:dispatch [::open-view {:view-id                        view-id
                                    :entity-id                      entity-id
                                    :signal                         signal
                                    :state-path                     state-path
                                    :subscribe-to-realtime-changes? subscribe-to-realtime-changes?}]]]})))

(rf/reg-event-fx
 ::cleanup
 [rf/trim-v]
 (fn [{:keys [db]} [{:keys [state-path] :as _ctx}]]
   (let [new-db (p/dissoc-in db state-path)]
     {:db new-db})))

(rf/reg-event-fx
 ::navigate-to-new-full-screen-card
 [rf/trim-v]
 (fn [{:keys [db]} [{:keys [state-path] :as _ctx} direction]]
   (let [selected-entity-id (get-in db (model/selected-entity-id-full-path state-path))
         selected-top-level-section (get-in db (model/selected-top-level-section-full-path state-path))
         selected-section (get-in db (model/selected-section-full-path state-path))
         view-id (get-in db (model/view-id-full-path state-path))
         view-entity (session-model/get-entity db view-id)
         view-configuration (:view/configuration view-entity)
         card-ids (get-in view-configuration [:top-level-sections selected-top-level-section :sections selected-section :cards])

         card-state-paths (->> card-ids
                               (mapv (fn [card-id]
                                       (model/card-state-full-path state-path selected-entity-id card-id))))
         ordered-states (->> card-state-paths
                             (mapv #(get-in db %)))

         prev-full-screen-card-idx
         (->> ordered-states
              (map-indexed (fn [card-idx card-state]
                             [card-idx card-state]))
              (keep (fn [[card-idx card-state]]
                      (when (:full-screen? card-state)
                        card-idx)))
              (first))

         new-full-screen-card-idx (case direction
                                    :next (inc prev-full-screen-card-idx)
                                    :previous (dec prev-full-screen-card-idx))

         new-ordered-card-states
         (->> ordered-states
              (map-indexed
               (fn [card-idx card-state]
                 (if (= card-idx prev-full-screen-card-idx)
                   (assoc card-state :full-screen? false)
                   (if (= card-idx new-full-screen-card-idx)
                     (assoc card-state :full-screen? true)
                     card-state)))))

         new-card-states (zipmap card-ids new-ordered-card-states)
         new-db (assoc-in db (conj (model/card-states-full-path state-path) selected-entity-id) new-card-states)]
     {:db new-db})))

(rf/reg-event-fx
 ::disable-view-success
 [rf/trim-v
  response-cofx/stale-response?]
 (fn [{:keys [db stale-response?]} [{:keys [state-path signal] :as _ctx} {:keys [view-id]}]]
   (when-not stale-response?
     (let [primary-entity-id (get-in db (model/primary-entity-id-full-path state-path))
           viewed-entity-type (->> view-id
                                   (model/get-entity db state-path)
                                   :view/entity-type)
           same-type-views (->> (session-model/get-entities db)
                                (filterv (fn [[_ entity]]
                                           (and (= (:entity/type entity) :entity.type/view)
                                                (= (:view/type entity) :view.type/single-entity)
                                                (= (:view/entity-type entity) viewed-entity-type)))))
           next-view (->> same-type-views
                          (vals)
                          (first))]
       {:fx [[:dispatch [::open-view {:view-id    (:db/id next-view)
                                      :entity-id  primary-entity-id
                                      :state-path state-path
                                      :signal     signal}]]]}))))

(rf/reg-event-fx
 ::save-view-success
 [rf/trim-v]
 (fn [{:keys [db]} [{:keys [state-path] :as _ctx} {:keys [view-entity]}]]
   (let [view-id (:db/id view-entity)
         primary-entity-id (get-in db (model/primary-entity-id-full-path state-path))]
     {:fx [[:dispatch [::open-view {:view-id    view-id
                                    :entity-id  primary-entity-id
                                    :state-path state-path}]]]})))

(rf/reg-event-fx
 ::open-view-editor
 [rf/trim-v]
 (fn [{:keys [db]} [{:keys [state-path] :as ctx} {:keys [create-new-view? clone-view? update-view?]}]]
   (let [view-id (get-in db (model/view-id-full-path state-path))
         primary-entity-id (get-in db (model/primary-entity-id-full-path state-path))
         view-entity (session-model/get-entity db view-id)
         view-entity-type (:view/entity-type view-entity)]
     {:fx [[:dispatch [::nev-view-editor-event/open-editor
                       {:view-id                             view-id
                        :clone-view?                         clone-view?
                        :update-view?                        update-view?
                        :create-new-view?                    create-new-view?
                        :entity-type                         view-entity-type
                        :preview-entity-id                   primary-entity-id
                        :save-view-success-callback-event    [::save-view-success ctx]
                        :disable-view-success-callback-event [::disable-view-success ctx]}]]]})))

;; Sidebar related stuff

(rf/reg-event-fx
 ::set-selected-section
 [rf/trim-v]
 (fn [{:keys [db]} [{:keys [state-path] :as _ctx} section-id]]
   {:db (-> db
            (assoc-in (model/selected-section-full-path state-path) section-id))}))

(rf/reg-event-fx
 ::fetch-sidebar-data-success
 [rf/trim-v
  response-cofx/stale-response?]
 (fn [{:keys [db stale-response?]} [{:keys [state-path] :as _ctx} resp]]
   (when-not stale-response?
     (let [entities (-> resp :body :data :entities)
           entities-by-id (p/index-by :db/id entities)]
       {:db (-> db
                (model/merge-entities state-path entities-by-id))}))))

(rf/reg-event-fx
 ::fetch-sidebar-data-failure
 [rf/trim-v
  response-cofx/stale-response?]
 (fn [{:keys [stale-response?] :as _cofx} [_ctx resp]]
   (when-not stale-response?
     ;; TODO: handle error in UI
     (js/console.log "Fetch sidebar data error " resp))))

(rf/reg-event-fx
 ::toggle-favorite-view-success
 [rf/trim-v
  response-cofx/stale-response?]
 (fn [_cofx [_ctx _resp]]
   ;; TODO:
   ))

(rf/reg-event-fx
 ::toggle-favorite-view-error
 [rf/trim-v
  response-cofx/stale-response?]
 (fn [_cofx [_ctx resp]]
   ;; TODO:
   (js/console.log "toggle fav error" resp)))

(rf/reg-event-fx
 ::toggle-favorite-view
 [rf/trim-v
  (rf/inject-cofx ::account-cofx/favorite-single-entity-views)]
 (fn [{:keys [db favorite-single-entity-views]} [{:keys [state-path] :as ctx}]]
   (let [view-id (get-in db (model/view-id-full-path state-path))
         view (model/get-entity db state-path view-id)
         view-entity-type (:view/entity-type view)
         currently-fav? (-> favorite-single-entity-views
                            (get view-entity-type)
                            (= view-id))
         new-favorite-single-entity-views (assoc favorite-single-entity-views
                                                 view-entity-type
                                                 (if currently-fav?
                                                   nil
                                                   view-id))]
     {::ws/send {:id         :account/update-preferences
                 :body       {:account/preference
                              {:favorite-single-entity-views new-favorite-single-entity-views}}
                 :on-success [::toggle-favorite-view-success ctx]
                 :on-error   [::toggle-favorite-view-error ctx]}})))

(rf/reg-event-fx
 ::set-sidebar-mode
 [rf/trim-v
  save-sidebar-mode-to-local-storage]
 (fn [{:keys [db]} [{:keys [state-path] :as _ctx} sidebar-mode]]
   {:db (assoc-in db (model/sidebar-mode-full-path state-path) sidebar-mode)}))

(rf/reg-fx
 ::scroll-sidebar-item-into-view
 (fn [element-id]
   (let [container (oops/ocall js/document "getElementById" "nev-sidebar-content-container")
         opened-item (oops/ocall js/document "getElementById" element-id)
         cb (fn []
              (let [container-rect (oops/ocall container "getBoundingClientRect")
                    item-rect (oops/ocall opened-item "getBoundingClientRect")
                    container-top (oops/oget container-rect "top")
                    item-top (oops/oget item-rect "top")]
                (when (< item-top container-top)
                  (oops/ocall opened-item "scrollIntoView" (clj->js {:behavior :instant})))))]
     ;; TODO: investigate if necessary to use requestAnimationFrame,
     ;; when the event dispatch is accompanied with the flush-dom metadata
     (js/requestAnimationFrame cb))))

(rf/reg-event-fx
 ::scroll-selected-sidebar-item-into-view
 [rf/trim-v]
 (fn [{:keys [db]} [{:keys [state-path] :as _ctx}]]
   (let [entity-id (get-in db (model/selected-entity-id-full-path state-path))]
     {::scroll-sidebar-item-into-view (str "nev-sidebar-item-" entity-id)})))

(rf/reg-event-fx
 ::set-selected-entity
 [rf/trim-v]
 (fn [{:keys [db]} [{:keys [state-path] :as ctx} {:keys [entity-id entity-type top-level-section-id] :as _args}]]
   (let [new-db (-> db
                    (assoc-in (model/selected-entity-id-full-path state-path) entity-id)
                    (assoc-in (model/selected-entity-type-full-path state-path) entity-type)
                    (assoc-in (model/selected-section-full-path state-path) (sevs/summary-section-id entity-type))
                    (assoc-in (model/selected-top-level-section-full-path state-path) top-level-section-id))]
     {:db new-db
      :fx [[:dispatch ^:flush-dom [::scroll-selected-sidebar-item-into-view ctx]]]})))

(rf/reg-event-fx
 ::create-linked-entity-success
 [rf/trim-v
  response-cofx/stale-response?
  (rf/inject-cofx ::session-cofx/session-context)]
 (fn [{:keys [db stale-response? session-context]}
      [{:keys [state-path] :as ctx} {linked-entity :entity}]]
   (when-not stale-response?
     (let [primary-entity-id (get-in db (model/primary-entity-id-full-path state-path))
           primary-entity (model/get-entity db state-path primary-entity-id)
           primary-entity-type (get-in db (model/primary-entity-type-full-path state-path))
           linked-entity-id (:db/id linked-entity)
           linked-entity-type (:entity/type linked-entity)

           ;; TODO: This breaks if multiple linked entity sections for primary entity that contain
           ;; the same entity type
           linked-entity-section (->> (sevs/available-sections session-context primary-entity-type)
                                      (filterv (fn [{:keys [id entity-types]}]
                                                 (and (sevs/linked-entity-section? id)
                                                      (->> entity-types
                                                           (some #(= linked-entity-type %))))))
                                      first)

           linked-entity-section-id (:id linked-entity-section)

           ;; Primary entity will be pre-populated in linked entity creator modal,
           ;; But user can in theory change it so have to check.
           ;; Discuss with PO how to handle that scenario
           open-linked-entity? (sevs/passes-section-entity-filter?
                                {:section-id        linked-entity-section-id
                                 :primary-entity    primary-entity
                                 :primary-entity-id primary-entity-id}
                                linked-entity)

           view-entity (->> (model/view-id-full-path state-path)
                            (get-in db)
                            (model/get-entity db state-path))]
       {:db (-> db
                (model/merge-entities state-path {linked-entity-id linked-entity}))
        :fx (vec
             (concat
              [[:fetch (fetch-sidebar-data-request
                        {:view-entity      view-entity
                         :viewed-entity-id primary-entity-id
                         :ctx              ctx})]]
              (when open-linked-entity?
                [[:dispatch [::set-selected-entity ctx {:entity-id            linked-entity-id
                                                        :entity-type          linked-entity-type
                                                        :top-level-section-id linked-entity-section-id}]]])))}))))

(rf/reg-event-fx
 ::delete-selected-entity-success
 [rf/trim-v
  response-cofx/stale-response?]
 (fn [{:keys [db stale-response?]} [{:keys [state-path] :as ctx}]]
   (when-not stale-response?
     (let [view-id (get-in db (model/view-id-full-path state-path))
           view-entity (model/get-entity db state-path view-id)
           primary-entity-id (get-in db (model/primary-entity-id-full-path state-path))
           primary-entity-type (get-in db (model/primary-entity-type-full-path state-path))
           selected-entity-id (get-in db (model/selected-entity-id-full-path state-path))]
       (if (= selected-entity-id primary-entity-id)
         ;; TODO: add other entity types once implemented
         {::routing/old-routing {:path-args (case primary-entity-type
                                              :entity.type/company [:companies-grid]
                                              :entity.type/person [:persons-grid]
                                              :entity.type/company-counterparty-diligence [:company-counterparty-diligence-grid]
                                              :entity.type/person-counterparty-diligence [:person-counterparty-diligence-grid]
                                              :entity.type/project-counterparty-diligence [:project-counterparty-diligence-grid])}}
         {:db (p/dissoc-in db (conj (model/entities-full-path state-path) selected-entity-id))
          :fx [[:dispatch [::set-selected-entity ctx {:entity-id            primary-entity-id
                                                      :entity-type          primary-entity-type
                                                      :top-level-section-id :primary-entity}]]
               [:fetch (fetch-sidebar-data-request
                        {:view-entity      view-entity
                         :viewed-entity-id primary-entity-id
                         :ctx              ctx})]]})))))

(rf/reg-event-db
 ::increment-card-remount-counter
 [rf/trim-v]
 (fn [db [{:keys [state-path] :as _ctx}]]
   (update-in db (model/card-remount-counter-full-path state-path) (fnil inc 1))))
